"use client";

import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import Image from "next/image";
import type { ContentImage } from "@/types/contentful/ContentImage";

interface Props {
  image: ContentImage;
  priority?: boolean;
  featured?: boolean;
  entryId?: string;
}

export const BlogImage = ({ image, priority = false, featured = false, entryId }: Props) => {
  const inspectorProps = useContentfulInspectorMode();
  return (
    <div {...(entryId ? inspectorProps({ entryId, fieldId: "media" }) : {})}>
      <Image
        src={image.src}
        alt={image.alt}
        width={image.width}
        height={image.height}
        className={featured ? "w-full aspect-video object-cover rounded-md" : "w-full h-auto rounded-md"}
        sizes="(min-width: 1024px) 690px, 100vw"
        priority={priority}
      />
    </div>
  );
};
